<template>
    <div class="main-contents display terms">
        <div class="tit">그레이트프로 뉴스 등록/수정<img src="/images/admin/list_shortcut.png" alt="목록가기" @click="$router.go(-1)"/></div>
        <div class="sub-tit"><p>그레이트프로 뉴스 등록/수정</p></div>
        <div class="banner_box">
            <div class="list">
                <div class="label">노출여부</div>
                <SelectComp title="노출여부" tagName="div" class="radio" type="radio" v-model="newsInfo.newsCenterExposureYn" list="Y:노출,N:노출종료" rules="required"/>
            </div>
            <div class="list">
                <div class="label">제 목</div>
                <InputComp title="제목" v-model="newsInfo.newsCenterTitle" maxByte="300" rules="required"/>
            </div>
            <div class="list">
                <div class="label">등록일</div>
                <SelectDate tagNm="div" type="date" class="select-box" classM="wd08" classD="wd08"  v-model="newsInfo.newsCenterReg" ></SelectDate>
            </div>
            <div class="list matter editor-box">
                <QuillEditor
                    ref="quillEditor"
                    v-model="tempNewsCenterCont"
                    placeholder="뉴스 내용을 입력하세요."
                    previewRoute="MAN938M05"
                    :previewTitle="'[ 그레이트프로 뉴스 ] '+ newsInfo.newsCenterTitle"
                    :previewAttaFileSeq="newsInfo.attaFileSeq"
                />
            </div>
            <div class="list bn_img">
                <div class="label">이미지</div>
                <file-select title="이미지" tagNm="div" type="admin" v-model="temp.newsImg" :name="newsInfo.attaFileNm" accept=".jpg,.jpeg,.png,.bmp,.gif" />
            </div>
        </div>
        <div class="select_btn">
			<div class="btn_01" @click="$router.go(-1)">취소</div>
			<div class="btn_02" v-if="paramSeq == ''" @click="save()">등록</div>
            <div class="btn_02" v-else style="background-color: #FF681D;" @click="save()">수정</div>
		</div>
    </div>
</template>

<script>
import fileSelect from "@/components/FileSelect.vue";
import QuillEditor from "@/components/QuillEditor.vue";

export default {
    components: { fileSelect, QuillEditor },

    data() {
        return {
            newsInfo : {
                newsCenterSeq : '',
                newsCenterExposureYn : '',
                newsCenterTitle : '',
                newsCenterReg : '',
                newsCenterCont : '',
                attaFileSeq : '',
                attaFileYn : '',
                attaFileNm : ''
            },
            temp : {},
            tempNewsCenterCont : '',

            paramSeq : this.$route.params.newsCenterSeq || '',
        }
    },
    beforeMount() {
        this.$.httpPost('/api/main/bbs/adm/news/getNewsInfo', {newsCenterSeq : this.paramSeq})
        .then(res=>{
            this.newsInfo = res.data.info || {};
            this.tempNewsCenterCont = res.data.info.newsCenterCont;

        }).catch(this.$.httpErrorCommon);
    },
    methods: {
        save() {
            var files = [];
            if(this.temp.newsImg instanceof File){
				files.push(this.temp.newsImg);
				this.newsInfo.attaFileYn = 'Y';
			}
            
            // 이모지 > HTML 변환
            this.newsInfo.newsCenterCont = this.$refs.quillEditor.getContentForSave();

            if (this.paramSeq == '') {
                this.$.popup('/adm/man/MAN938P07')
                .then(res => {
                    if(res) {
                        this.$.fileUpload('IMG', files, '/api/main/bbs/adm/news/setNews', this.newsInfo)
                        .then(() => {
                            alert('저장이 완료되었습니다.');
                            this.$router.go(-1);
                        }).catch(this.$.httpErrorCommon);
                    }    
                });
            } else {
                this.$.popup('/adm/man/MAN938P08')
                .then(res => {
                    if(res) {
                        this.$.fileUpload('IMG', files, '/api/main/bbs/adm/news/setNews', this.newsInfo)
                        .then(() => {
                            alert('수정이 완료되었습니다.');
                            this.$router.go(-1);
                        }).catch(this.$.httpErrorCommon);
                    }    
                });
            }
            
            
        }
    }
}
</script>